<template>
</template>
<script>
  export default {
    data() {
      let vm = this;
      return {
        element: null,
        resources: {
          width: {
            name: 'width',
            defaultValue: '500',
            min: '450',
            max: '1500',
            labelDesc: 'width',
            callback: function () {
              vm.resources.width.defaultValue = this.value;
              vm.element.internal_config.width = this.value + 'px';

            },
          },
          blogPerPage: {
            name: 'blogPerPage',
            defaultValue: 8,
            min: '2',
            max: '20',
            labelDesc: 'news-per-page',
            callback: function () {
              vm.resources.blogPerPage.defaultValue = this.value;
              vm.element.internal_config.perPage = this.value;
              vm.element.perPage = this.value;


            },
          },
          height: {
            name: 'height',
            defaultValue: 150,
            min: '50',
            max: '500',
            labelDesc: 'height-content',
            callback: function () {
              vm.resources.height.defaultValue = this.value;
              vm.element.internal_config.contentStyle.height = this.value+ 'px';
            },
          },
          text: {
            name: 'blogInputText',
            defaultValue: '',
            labelDesc: 'read-more-text',
            canRemove: false,
            max: 20,
            callback: function () {
              vm.resources.text.defaultValue = this.value;
              vm.element.internal_config.textReadMore = this.value;
            },
          },

          subTextStyle: {
            name: 'blogTitleStyle',
            defaultFamily: '',
            defaultSize: '',
            defaultColor: '',
            defaultSizeMobile: '',
            shitOptions: true,
            showSizeMobile: true,
            defaultStroke: '',
            defaultAlign: '',
            labelDesc: 'blogTitleStyle',
            callback: function () {

              vm.resources.subTextStyle.defaultFamily = this.family;
              vm.element.internal_config.titleStyle.family = this.family;

              vm.resources.subTextStyle.defaultSize = this.size + 'px';
              vm.element.internal_config.titleStyle.size = this.size + 'px';

              vm.resources.subTextStyle.defaultSizeMobile = this.sizeMobile + 'px';
              vm.element.internal_config.titleStyle.sizeMobile = this.sizeMobile + 'px';

              vm.resources.subTextStyle.defaultColor = this.color;
              vm.element.internal_config.titleStyle.color = this.color;

              vm.resources.subTextStyle.defaultAlign = this.align;
              vm.element.internal_config.titleStyle.align = this.align;

              vm.resources.subTextStyle.defaultWeight = this.weight;
              vm.element.internal_config.titleStyle.weight = this.weight;

              vm.resources.subTextStyle.defaultStyle = this.style;
              vm.element.internal_config.titleStyle.style = this.style;

              vm.resources.subTextStyle.defaultStroke = this.stroke;
              vm.element.internal_config.titleStyle.stroke = this.stroke;

            },
          },
          subTextContent: {
            name: 'subTextContent',
            defaultFamily: '',
            defaultSize: '',
            defaultColor: '',
            defaultSizeMobile: '',
            shitOptions: true,
            showSizeMobile: true,
            defaultStroke: '',
            defaultAlign: '',
            labelDesc: 'subTextContent',
            callback: function () {

              vm.resources.subTextStyle.defaultFamily = this.family;
              vm.element.internal_config.contentStyle.family = this.family;

              vm.resources.subTextStyle.defaultSize = this.size + 'px';
              vm.element.internal_config.contentStyle.size = this.size + 'px';

              vm.resources.subTextStyle.defaultSizeMobile = this.sizeMobile + 'px';
              vm.element.internal_config.contentStyle.sizeMobile = this.sizeMobile + 'px';

              vm.resources.subTextStyle.defaultColor = this.color;
              vm.element.internal_config.contentStyle.color = this.color;

              vm.resources.subTextStyle.defaultAlign = this.align;
              vm.element.internal_config.contentStyle.align = this.align;

              vm.resources.subTextStyle.defaultWeight = this.weight;
              vm.element.internal_config.contentStyle.weight = this.weight;

              vm.resources.subTextStyle.defaultStyle = this.style;
              vm.element.internal_config.contentStyle.style = this.style;

              vm.resources.subTextStyle.defaultStroke = this.stroke;
              vm.element.internal_config.contentStyle.stroke = this.stroke;

            },
          },
          colorReadMore: {
            name: 'backgroundColor',
            defaultValue: '#ffffff',
            gradient: false,
            labelDesc: 'color-read-more',
            callback: function () {
              vm.resources.colorReadMore.defaultValue = this.colorValue;
              vm.element.internal_config.colorReadMore = this.colorValue;
            },
          },
          colorHoverReadMore: {
            name: 'colorHoverReadMore',
            defaultValue: '#000',
            gradient: false,
            labelDesc: 'color-read-more-hover',
            callback: function () {
              vm.resources.colorHoverReadMore.defaultValue = this.colorValue;
              vm.element.internal_config.colorReadMoreHover = this.colorValue;
            },
          },
          colorTitle: {
            name: 'backgroundColorContainer',
            defaultValue: '#000',
            gradient: false,
            labelDesc: 'resource-bg-color',
            callback: function () {
              vm.resources.colorTitle.defaultValue = this.colorValue;
              vm.element.internal_config.cardBgColor = this.colorValue;
            },
          },
          colorDetails: {
            name: 'backgroundColorSelected',
            defaultValue: '#000',
            gradient: false,
            labelDesc: 'color-details',
            callback: function () {
              vm.resources.colorDetails.defaultValue = this.colorValue;
              vm.element.internal_config.colorDetails = this.colorValue;
            },
          },

          theme: {
            name: 'themeBlog',
            defaultValue: '',
            labelDesc: 'theme-blog',
            options: [
              {name: vm.$t('ct-theme-blog-align-left'), value: 1, selected: 'selected', disabled: false},
              {name: vm.$t('ct-theme-blog-align-right'), value: 2, selected: false, disabled: false},
              {name: vm.$t('ct-theme-blog-align-mix'), value: 3, selected: false, disabled: false},
              // {name: vm.$t('ct-theme-blog-cards'), value: 4, selected: false, disabled: false},
              {name: vm.$t('ct-theme-blog-grid'), value: 5, selected: false, disabled: false},
            ],
            callback: function () {
              vm.resources.theme.defaultValue = this.value;
              vm.element.internal_config.theme = this.value;
            }
          },
          dateFormat: {
            name: 'type',
            defaultValue: '',
            labelDesc: 'format-date',
            options: [
              {name: '2020-01-01', value: 'YYYY-MM-DD', selected: 'selected', disabled: false},
              {name: '2020-01-01 12:00', value: 'YYYY-MM-DD H:mm', selected: false, disabled: false},
              {name: '01/01/2020', value: 'DD/MM/YYYY', selected: false, disabled: false},
              {name: '01/01/2020 12:00', value: 'DD/MM/YYYY H:mm', selected: false, disabled: false},
            ],
            callback: function () {
              vm.resources.dateFormat.defaultValue = this.value;
              vm.element.internal_config.dateFormat = this.value;
            }
          },

        }
      }
    },
    methods: {
      setMinValuesData(resource, value) {
        this.resources[resource].min = parseInt(value);
      },
      setValuesData(data) {
        this.element = data;


        this.resources.colorReadMore.defaultValue = data.internal_config.colorReadMore;
        this.resources.colorHoverReadMore.defaultValue = data.internal_config.colorReadMoreHover;
        this.resources.colorTitle.defaultValue = data.internal_config.cardBgColor;
        this.resources.colorDetails.defaultValue = data.internal_config.colorDetails;
        this.resources.theme.defaultValue = data.internal_config.theme;
        this.resources.text.defaultValue = data.internal_config.textReadMore;

        this.resources.height.defaultValue = data.internal_config.contentStyle.height;


        this.resources.subTextStyle.defaultFamily = data.internal_config.titleStyle.family;
        this.resources.subTextStyle.defaultSize = data.internal_config.titleStyle.size;
        this.resources.subTextStyle.defaultSizeMobile = data.internal_config.titleStyle.sizeMobile;
        this.resources.subTextStyle.defaultColor = data.internal_config.titleStyle.color;
        this.resources.subTextStyle.defaultAlign = data.internal_config.titleStyle.align;
        this.resources.subTextStyle.defaultWeight = data.internal_config.titleStyle.weight;
        this.resources.subTextStyle.defaultStyle = data.internal_config.titleStyle.style;
        this.resources.subTextStyle.defaultStroke = data.internal_config.titleStyle.stroke;

        this.resources.subTextContent.defaultFamily = data.internal_config.contentStyle.family;
        this.resources.subTextContent.defaultSize = data.internal_config.contentStyle.size;
        this.resources.subTextContent.defaultSizeMobile = data.internal_config.contentStyle.sizeMobile;
        this.resources.subTextContent.defaultColor = data.internal_config.contentStyle.color;
        this.resources.subTextContent.defaultAlign = data.internal_config.contentStyle.align;
        this.resources.subTextContent.defaultWeight = data.internal_config.contentStyle.weight;
        this.resources.subTextContent.defaultStyle = data.internal_config.contentStyle.style;
        this.resources.subTextContent.defaultStroke = data.internal_config.contentStyle.stroke;


        this.resources.dateFormat.defaultValue = data.internal_config.dateFormat;
        this.resources.width.defaultValue = data.internal_config.width;

        this.resources.blogPerPage.defaultValue = data.internal_config.perPage;

      },
      getValuesData() {
        return this.resources;
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/Blog/Feed/Resources.vue